import * as React from "react"
import Layout from "./src/layout"
import { ChakraProvider } from "@chakra-ui/react"
import theme from "./src/theme"

import "./src/css/global.css"

const DATAWRAPPER_ORIGIN = "https://datawrapper.dwcdn.net"
const DATAWRAPPER_IFRAME_SELECTOR =
  'iframe[src^="https://datawrapper.dwcdn.net/"]'

let datawrapperResizeListenerInstalled = false

const handleDatawrapperResize = event => {
  if (event.origin !== DATAWRAPPER_ORIGIN) return

  const heights = event.data?.["datawrapper-height"]
  if (!heights || typeof heights !== "object") return

  const height = Object.values(heights).find(
    value => Number.isFinite(Number(value)) && Number(value) > 0
  )
  if (height === undefined) return

  document.querySelectorAll(DATAWRAPPER_IFRAME_SELECTOR).forEach(iframe => {
    if (iframe.contentWindow === event.source) {
      iframe.style.height = `${Number(height)}px`
    }
  })
}

export const onClientEntry = () => {
  if (datawrapperResizeListenerInstalled) return

  window.addEventListener("message", handleDatawrapperResize)
  datawrapperResizeListenerInstalled = true
}

export const wrapPageElement = ({ element, props }) => {
  // props provide same data to Layout as Page element will get
  // including location, data, etc - you don't need to pass it
  return <Layout {...props}>{element}</Layout>
}

export const wrapRootElement = ({ element }) => {
  return (
    <ChakraProvider theme={theme} resetCSS={true} portalZIndex={1000}>
      {element}
    </ChakraProvider>
  )
}
